import { HistoryMessage } from 'types/chat/messages/message';

interface GetMessagesResponse {
  id: number;
  date: string;
  status: string;
  type: string;
  direction: 'outgoing' | 'incoming';
  message: string;
  fileUrl: string | null;
  reaction: any;
  replyMessage: any;
  sessionId: string | null;
  formattedMessage: string | null;
  manager: { id: string; fullName: string } | null;
  imported: boolean | null;
  recovered: boolean | null;
  isForwarded?: boolean | null;
}

export function convertGetMessagesToHistoryMessage(
  message: GetMessagesResponse
): HistoryMessage {
  return {
    Id: message.id,
    Type: message.direction === 'outgoing' ? 'outcoming' : message.direction,
    Message: message.message,
    FileType: message.type as any,
    File: message.fileUrl || null,
    Status: message.status as any,
    DateCreate: message.date,
    Reply: message.replyMessage || null,
    reactions: message.reaction || null,
    Imported: message.imported || null,
    Recovered: message.recovered || null,
    IsForwarded: message.isForwarded || null,
    // שדות שאין צורך בהם - מוגדרים כ-null
    GlobalUserId: null,
    GlobalUserName: null,
    GlobalUserImage: null,
    StatusHeb: null,
    StringFormatedMessageWithDate: null,
    // שדות אופציונליים
    WebsitePreviewObj: null,
    isFavourite: null,
    BotName: null,
    Object: null,
    TempId: null,
  };
}

